export function formatDuration(timeInSeconds: number | null) {
  if (timeInSeconds === null) {
    return ''
  }

  const minutes = Math.floor(timeInSeconds / 60)
  const seconds = Math.floor(timeInSeconds % 60)

  if (!minutes) {
    return `${seconds}s`
  }
  if (!seconds) {
    return `${minutes}min`
  }
  return `${minutes}min ${seconds}s`
}
